import { Button } from "common/components/ui/Button";
import { DialogDescription, DialogTitle } from "common/components/ui/Dialog";
import { DrawerDescription, DrawerTitle } from "common/components/ui/Drawer";
import useLicenseMutations from "common/datahooks/useLicenseMutations";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface RemoveCancellationProps {
  accountId: string;
  goBack: () => void;
  onSuccess: () => void;
}

export default function RemoveCancellation({
  accountId,
  goBack,
  onSuccess,
}: RemoveCancellationProps) {
  const isDesktop = useTwBreakpoint("lg");

  const { removeLicenseCancellation, isRemovingLicenseCancellation } =
    useLicenseMutations();

  function onClick() {
    removeLicenseCancellation({ accountId }).then(onSuccess);
  }

  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  return (
    <>
      <Title>Remove scheduled cancellation?</Title>
      <Description className="mb-8">
        The seat for this account will renew on your next billing date. You can
        review your subscription at any time in your subscription settings.
      </Description>
      <div className="flex justify-between gap-x-2.5">
        <Button
          onClick={goBack}
          variant="secondary-black"
          disabled={isRemovingLicenseCancellation}
          className="lg:flex-1"
        >
          Cancel
        </Button>
        <Button
          isLoading={isRemovingLicenseCancellation}
          onClick={onClick}
          variant="outline-danger"
          className="lg:flex-1"
        >
          Remove cancellation
        </Button>
      </div>
    </>
  );
}
